<template>
  <div id="app">
    <flipbook
      ref="flipbook"
      class="flipbook"
      v-slot="flipbook"
      :pages="pages"
      :startPage="1"
      :zooms="zooms"
      :clickToZoom="false"
      :dragToFlip="true"
      :ambient="1"
      :gloss="0.05"
      :nPolygons="20"
      :centering="true"
      @flip-left-end="onFlipEnd"
      @flip-right-end="onFlipEnd">
      <div class="action__bar__wrapper">
        <div class="action__bar visible">
          <button
            class="action__bar__btn left"
            :disabled="!flipbook.canFlipLeft"
            @click="flipbook.flipLeft">
          </button>
          <span class="action__bar__page__num">
            {{ flipbook.page - 1 }}
          </span>
          <button
            class="action__bar__btn right"
            :disabled="!flipbook.canFlipRight"
            @click="flipbook.flipRight"
          ></button>
          <span class="action__bar__page__total">
            共 {{ flipbook.numPages - 1 }} 页
          </span>
          <i class="action__bar__slice"></i>
          <button
            class="action__bar__zoom plus"
            :disabled="!flipbook.canZoomIn"
            @click="flipbook.zoomIn">
            <icon-plus></icon-plus>
          </button>
          <button
            class="action__bar__zoom minus"
            :disabled="!flipbook.canZoomOut"
            @click="flipbook.zoomOut">
            <icon-minus></icon-minus>
          </button>
        </div>
      </div>
    </flipbook>
  </div>
</template>

<script>
import Flipbook from 'flipbook-vue'
import IconPlus from './components/IconPlus.vue'
import IconMinus from './components/IconMinus.vue'
import { setTimeout } from 'timers';

export default {
  components: { Flipbook, IconPlus, IconMinus },

  data () {
    return {
      flipbook: null,
      zooms: [1],
      pages: []
    }
  },

  methods: {
    onFlipEnd () {
      if (this.flipbook.page === 1) {
        document.querySelector('.left.click-to-flip').style.opacity = 0
      } else {
        document.querySelector('.left.click-to-flip').style.opacity = 1
      }
      if (this.flipbook.page === this.flipbook.numPages - 1) {
        document.querySelector('.right.click-to-flip').style.opacity = 0
      } else {
        document.querySelector('.right.click-to-flip').style.opacity = 1
      }
    },
    resize () {
      const ww = window.innerWidth
      const wh = window.innerHeight
      if (ww >= 636 * 2 * 1.8) {
        this.zooms = [1, 1.5]
      }
      if (ww / wh <= 1) {
        const suffix = `?imageMogr2/thumbnail/!${ww * 2}x${wh * 2}r/gravity/Center/crop/${ww * 2}x${wh * 2}`
        this.pages = [
          null,
          `https://cdn-static.sspai.com/page/macintosh/pc_1/cover.jpeg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_1.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_2.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_3.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_4.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_5.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_6.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_7.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_8.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_9.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_10.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_11.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_12.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_13.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_14.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_15.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_16.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_17.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_18.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_19.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_20.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_21.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_22.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_23.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_24.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_25.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_26.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_27.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_28.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_29.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_30.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_31.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_32.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_33.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_34.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_35.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_36.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_37.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_38.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_39.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_40.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_41.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_42.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_43.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_44.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_45.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_46.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_47.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_48.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_49.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_50.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_51.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_52.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_53.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_54.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_55.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_56.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_57.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_58.jpg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_59.jpeg${suffix}`,
          `https://cdn-static.sspai.com/page/macintosh/mb_1/page_60.jpeg${suffix}`,
        ]
      } else {
        this.pages = [
          null,
          'https://cdn-static.sspai.com/page/macintosh/pc_1/cover.jpeg?imageMogr2/thumbnail/636x/gravity/Center/crop/636x822',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_1.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_2.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_3.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_4.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_5.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_6.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_7.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_8.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_9.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_10.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_11.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_12.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_13.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_14_1.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_15.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_16_1.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_17.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_18.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_19.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_20.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_21.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_22.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_23.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_24.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_25.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_26.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_27.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_28.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_29.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_30.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_31.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_32.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_33.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_34.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_35.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_36.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_37.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_38.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_39.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_40.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_41.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_42.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_43.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_44.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_45.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_46.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_47.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_48.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_49.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_50.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_51.jpeg',
          'https://cdn-static.sspai.com/page/macintosh/pc_1/page_52.jpeg',
        ]
      }
    },
    route () {
      console.log('click')
      if (this.flipbook.page === 44 || this.flipbook.page === 53) {
        window.open('https://sspai.com/page/retro')
      }
    }
  },

  created () {
    const ww = window.innerWidth
    const wh = window.innerHeight
    document.body.style.width = `${ww}px`
    document.body.style.height = `${wh}px`
    document.body.style.setProperty('--h', `${wh}px`)
    this.resize()
  },

  mounted () {
    this.flipbook = this.$refs.flipbook
    const flipbook = this.flipbook
    
    window.addEventListener('keydown', ev => {
      if (!flipbook) return
      if (ev.keyCode === 37 && flipbook.canFlipLeft) {
        flipbook.flipLeft()
      }
      if (ev.keyCode === 39 && flipbook.canFlipRight) {
        flipbook.flipRight()
      }
    })

    setTimeout(() => {
      if (!flipbook) return
      if (flipbook.canFlipRight) {
        flipbook.zoomIn()
        flipbook.flipRight()
      }
    }, 1000)

    setTimeout(() => {
      const actionBar = document.querySelector('.action__bar')
      if (actionBar) {
        actionBar.classList.remove('visible')
      }
    }, 2000)

    // const boundingBox = document.querySelector('.flipbook .bounding-box')
    // const el = document.createElement('div')
    // el.classList.add('click__area')
    // boundingBox.appendChild(el)
    // el.addEventListener('click', this.route)
  }
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
  overflow: hidden;
  --h: 100vh;
}

#app {
  width: 100%;
  height: 100%;
}
.flipbook {
  width: 100%;
  height: 100%;
  margin: auto;
}
.flipbook .bounding-box {
  box-shadow: 8px 8px 15px -1px rgba(0, 0, 0, 0.12);
}

.flipbook .bounding-box .click__area {
  display: block;
  position: absolute;
  width: 38.52%;
  padding-top: 18.47%;
  background: #ccc;
  opacity: 0;
  left: 05.58%;
  top: 22.63%;
  cursor: pointer;
}

.flipbook .polygon.blank {
  background-color: #FAF1DA!important;
  background-image: url(https://cdn-static.sspai.com/page/macintosh/mb_bg.jpeg);
  background-size: cover;
}

.flipbook .click-to-flip {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flipbook .click-to-flip::after {
  content: '';
  display: inline-block;
  font-size: 83px;
  font-weight: 600;
  color: rgba(217, 217, 217, 0.4);
  writing-mode: vertical-lr;
  line-height: 116px;
}

.flipbook .left.click-to-flip::after {
  content: '上一页';
  position: absolute;
  right: 592px;
}
.flipbook .right.click-to-flip::after {
  content: '下一页';
  position: absolute;
  left: 592px;
}

.action__bar__wrapper {
  position: fixed;
  bottom: 0;
  z-index: 99;
  width: 60%;
  height: 25vh;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-aspect-ratio: 1 / 1) {
  .flipbook .bounding-box .click__area {
    display: block;
    position: absolute;
    width: calc(337 / 428 * 100%);
    padding-top: calc(413 / 428 * 100%);
    background: #ccc;
    opacity: 0;
    left: 14.02%;
    top: calc(197 / 428 * 100vw - ((100vw * 926 / 428 - var(--h)) / 2));
  }
  .action__bar__wrapper {
    width: 100%;
    height: 15vh;
  }
}

.action__bar {
  background: #4A4A4A;
  border-radius: 8px;
  height: 58px;
  box-sizing: border-box;
  padding: 12px 16px;
  color: #fff;
  display: inline-flex;
  align-items: center;

  opacity: 0;
  transition: .2s
}

.action__bar__wrapper:hover .action__bar,
.action__bar__wrapper .action__bar.visible {
  opacity: 1;
}

.action__bar__btn {
  --border-color: #ffffff;
  --bg-color: #606060;
  width: 34px;
  height: 34px;
  border-radius: 4px;
  background: var(--bg-color);
  border: none;
  -webkit-highlight: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: .2s;
}

.left.action__bar__btn::before {
  content: '';
  display: inline-block;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid var(--border-color);
}

.right.action__bar__btn::before {
  content: '';
  display: inline-block;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid var(--border-color);
}

.action__bar__btn:hover,
.action__bar__btn:active {
  --bg-color: #000000;
}

.action__bar__btn:disabled {
  cursor: not-allowed;
  --border-color: #8D8D8D;
}

.action__bar__page__num {
  width: 76px;
  height: 34px;
  line-height: 34px;
  background: #606060;
  border-radius: 4px;
  text-align: center;
  margin: 0 1px;
}

.action__bar__page__total {
  margin: 0 12px;
}

.action__bar__slice {
  display: inline-block;
  width: 1px;
  height: 58px;
  background: #D9D9D9;
}

.action__bar__zoom {
  --path-color: #fff;
  background: none;
  border: none;
  -webkit-highlight: none;
  cursor: pointer;
  width: 24px;
  height: 24px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 24px;
}

.action__bar__zoom:hover,
.action__bar__zoom:active {
  --path-color: #090909;
}

.action__bar__zoom:disabled {
  --path-color: #8D8D8D;
}
</style>
